module.exports = __webpack_public_path__ + "static/media/alert-blue-icon.c09f084d.svg";